export type TTrades = {
  overView: {
    openTrades: number;
    closedTrades: number;
    openInvAmt: number;
    closedinvAmt: number;
    freightAmt: number;
    commodityCost: number;
    platformFee: number;
    demandCount: number;
    pendingRcvble: number;
    pendingPayble: number;
    cancelledTrades: number;
  };
  trades: TAllTrades[];
};

export type TAllTrades = {
  account: null | string;
  arlDate: null | string;
  arlTime: null | string;
  comm: number;
  date: null | string;
  destAddrLine: string;
  destAltMobile: null | string;
  destCity: string;
  destMarketName: string;
  destMobile: string;
  destName: string;
  destPartyId: number;
  cancelReason: string;
  destShopNum: string;
  destTradeName: string;
  discount: number;
  destDisc: number | "";
  srcDisc: number | "";
  freightPaid: number;
  frieghtAmt: number;
  ifsc: null | string;
  progDate: string;
  images: Array<{
    id: number;
    reqId: number;
    tradeId: number;
    imgFrom: string;
    status: 1;
    type: string;
    url: string;
  }>;
  invAmt: number;
  inwardPmt: number;
  lbrCharges: number;
  misc: number;
  outwardPmt: number;
  pattiAmt: number;
  payableTo: unknown;
  srcMobile: string;
  srcName: string | null;
  srcPartyId: number;
  srcTradeName: string | null;
  timeStamp: string;
  totalPayable: number;
  tradeId: number;
  tradeMode: "ORDER" | "COMMISSION";
  tradeStatus: string;
  traderSeq: number;
  srcAddrLine: string;
  srcCity: string;
  srcMarketName: string;
  srcTradeStatus: string;
  srcDist: string;
  srcPincode: string;
  destDist: string;
  destPincode: string;
  srcState: string;
  destState: string;
  updatedOn: string;
  destTradeStatus: string;
  closedDate: string;
  destProfilePic: string;
  srcProfilePic: string;
  srcChequeStatus: string;
  destChequeStatus: string;
  srcDocStatus: string;
  destDocStatus: string;
  destClosedDate: string;
  srcRmId: number;
  destRmId: number;
};

export type TTradeDetailsById = {
  srcAdv: number;
  destAdv: number;
  waBal: number;
  loanAppId: number;
  cancelReason: string;
  createdOn: string;
  balancePayable: number;
  balanceReceivable: number;
  date: string;
  destAddrLine: string;
  destAltMobile: string;
  destEsign: string;
  srcEsign: string;
  gstAmountSrc: number;
  acceptTradeDate: string;
  srcTradeEsign: string;
  destCity: string;
  destMarketName: string;
  destMobile: string;
  destName: string;
  destPartyId: number;
  destShopNum: string;
  destShipAddrLine: string;
  destShipCity: string;
  destShipstate: string;
  destShipPincode: string;
  otherCharges: number;
  mandiFee: number;
  destTradeName: string;
  images: Array<TTradeDocument>;
  invoices: TTradeDocument[];
  receipts: TTradeDocument[];
  otherDocumets: TTradeDocument[];
  srcAddrLine: string;
  srcAltMobile: string;
  srcCity: string;
  srcMarketName: string;
  srcMobile: string;
  srcName: string;
  srcPartyId: number;
  srcShopNum: string;
  srcTradeName: string;
  timeStamp: string;
  tradeId: number;
  traderId: number;
  flag: boolean;
  tradeStatus: TTradeStatus;
  selectedTrader: any;
  destRmName: string;
  destRmMobile: string;
  srcRmName: string;
  srcRmMobile: string;
  traderSeq: number;
  selectedCrop: TCrop[];
  freightAmt: number | "";
  lineItems: TCrop[];
  totalPayable: number | "";
  arlDate: string;
  comm: number | "";
  pattiAmt: number | "";
  lbrCharges: number | "";
  discount: number | "";
  destDisc: number | "";
  srcDisc: number | "";
  misc: number | "";
  payment: number | "";
  paidDate: string;
  arlTime: string;
  paidAmt: number;
  balPayable: number;
  progress: TProgress[];
  arlConf: {
    date: string;
    freightAmt: number | "";
    images: Array<TTradeDocument>;
    time: TTime;
  };
  pattiFinal: {
    freightAmt: number | "";
    images: Array<TTradeDocument>;
    comm: number | "";
    totalPayable: number | "";
    pattiAmt: number | "";
    lbrCharges: number | "";
    discount: number | "";
    misc: number | "";
  };
  pmtDtls: {
    account: string;
    ifsc: string;
    images: Array<TTradeDocument>;
    payableTo: string;
    payment: number | "";
    totalPayable: number | "";
  };
  invoiceAmt: number | "";
  arrivalDocs: TTradeDocument[];
  arrivalWeightDocs: TTradeDocument[];
  pattiDocs: TTradeDocument[];
  paymentDocs: TTradeDocument[];
  tradeMode: string;
  invAmt: number | "";
  paymentType: string;
  tradeAcceptedTime: string;
  inwardPmt: number;
  outwardPmt: number;
  freightAdv: number | "";
  tradecomments: string;
  freightPaid: number | "";
  weightAtSrc: number | "";
  destWeight: number | "";
  destWastage: number | "";
  netWeight: number | "";
  arlComments: string;
  balFreightAmt: number | "";
  arrivalWeightbridgeDocs: TTradeDocument[];
  reqAdvanceDocuments: TTradeDocument[];
  pattiDate: string;
  advancePaid: number;
  advanceRcvd: number;
  pattiComments: string;
  commPerVal: number | "";
  finalPayable: number;
  srcPf: number | "";
  paymentMode: string | number;
  paymentComments: string;
  moistureLoss: number;
  avgRate: number;
  pmtHistory: TPaymentHistory[];
  totalReceivable: number;
  destDelayCharges: number;
  srcDelayCharges: number;
  destPmtTerm: string;
  srcPmtTerm: string;
  dueDate: string;
  srcAccount: string;
  srcAccountHoler: string;
  srcBankName: string;
  srcIfsc: string;
  platformFeeVal: number | "";
  platformFeeTotal: number | "";
  delayedChargesVal: number | "";
  delayedChargesPer: number | "";
  paymentTerms: number | "";
  rate: number | "";
  finalRate: number | "";
  finalInvoice: number | "";
  destRate: number | "";
  destPf: number | "";
  srcDis: number | "";
  destDis: number | "";
  tradeType: string | "";
  destPfPer: number | "";
  srcPfPer: number | "";
  company: string | "";
  delayedDays: string;
  destPfDisc: number;
  srcPfDisc: number;
  srcPmtHistory: TPaymentHistory[];
  destPmtHistory: TPaymentHistory[];
  srcVehNum: string | "";
  destVehNum: string | "";
  advanceLimit: number | "";
  reqAdv: TReqAdv;
  commodityCost: number | "";
  cmdityCost: number | "";
  srcTradeStatus: string;
  finalReceivable: number;
  srcDist: string;
  srcPincode: string;
  destDist: string;
  destPincode: string;
  srcState: string;
  destState: string;
  updatedOn: string;
  unitPriceSrc: number | string;
  totalAmountSrc: number;
  payableAfterGstSrc: number;
  srcTax: string;
  destTax: string;
  destInvId: string;
  srcInvId: string;
  srcPfId: string;
  destPfId: string;
  gstAmountDest: number;
  unitPriceDest: number | string;
  totalAmountDest: number;
  payableAfterGstDest: number;
  destTradeStatus: TTradeStatus;
  payAcc: TPayoutDetails;
  driverName: string;
  driverMobile: string;
  containerId: string;
  closedDate: string;
  srcAgremetTimestamp: string;
  srcPfRate: number;
  destPfRate: number;
  destPmtTermLabel: string;
  srcPmtTermLabel: string;
  agreements: TAgreements[];
  tradeContractAgreement: TAgreements | null;
  tradeAcceptanceAgreement: TAgreements | null;
  tradeAdvanceAgreement: TAgreements | null;
  reqId: number;
  demandCreatedOn: string;
  freightDtls: {
    tradeId: number;
    freightAmt: number;
    freightAdv: number;
    freightPaid: number;
    srcVehNum: string;
    srcDriverMobile: number;
    srcDriverName: string;
    destVehNum: string;
    destDriverName: string;
    destDriverMobile: number;
    pmtMode: string;
    pmtType: string;
    pmtStatus: string;
    comments: string;
    descr: string;
    utr: string;
    paidTo: string;
    date: string;
    pmtDate: string;
    imgs: Array<TTradeDocument>;
    containerId: string;
    helperMobile: string;
    helperName: string;
    tid: number;
    transMobile: string;
    transName: string;
    city: string;
    state: string;
    rate: number;
    rateUnit: string;
    tenant: string;
  };
  srcChequeStatus: string;
  destChequeStatus: string;
  srcDocStatus: string;
  destDocStatus: string;
  waInfo: TWalletInfo;
  srcGstNo: string;
  destGstNo: string;
  tradeInvs: TAgreements[];
  tradeSrcTapalPdf: TAgreements | null;
  tradeDestTapalPdf: TAgreements | null;
  tradeSrcPattiPdf: TAgreements | null;
  tradeDestPattiPdf: TAgreements | null;
  tradeSrcPfTaxPdf: TAgreements | null;
  tradeDestPfTaxPdf: TAgreements | null;
  tradeSrcInvoicePdf: TAgreements | null;
  tradeDestInvoicePdf: TAgreements | null;
  destClosedDate: string;
  dispatchTime: string;
  deliveryDate: string;
  rateType: string;
  srcRmId: number;
  destRmId: number;
  totalWeight: number;
  totalQty: number;
  pickDate: string;
  pickTime: string;
  totalNetWeight: number;
  totalDestWeight: number;
  totalDestQty: number;
  loanAccNo: number;
  tradeDestDelayChargesPdf: TAgreements | null;
};

export type TWalletInfo = {
  uid: string;
  date: string;
  amount: number;
};

export type TTradeDocument = {
  id: number;
  reqId: number;
  tradeId: number;
  imgFrom: string;
  url: string;
  type:
    | "TAPAL_INVOICE"
    | "WEIGH_BRIDGE"
    | "OTHER"
    | "TRANSPORT_PAYMENT"
    | "ARRIVAL_WEIGHT_BRIDGE"
    | "PATTI"
    | "PAYMENT";
  status: number;
  docType: "image" | "pdf";
  typeId: number;
};

export type TPaymentHistory = {
  id: number;
  reqId: number;
  pmtMode: string;
  date: string;
  amount: number;
  balance: number;
  comments: string;
  pmtType: string;
  accHolderName: string;
  accNo: number;
  source: string;
  tradeId: number;
  traderId: number;
  images: Array<TTradeDocument>;
  imgs: Array<TTradeDocument>;
  inOutWard: string;
  typeId: number;
  payoutId: string;
  refId: string;
  product: string;
  fundAccId: string;
  pmtStatus: string;
  pmtReceiptDate: string;
  desc: string;
  utr: string;
  createdOn: string;
  destTradeNAme: string;
  paymentType: string;
  pmtId: number;
  url: string;
  rejectedReason: string;
  note1: string;
  note2: string;
  fees: number;
  tax: number;
  addtComments: string;
  updatedOn: String;
  waAmount: number;
  amtRcvd: number;
};
export type TTradeStatus =
  | "PENDING"
  | "ACCEPTED"
  | "ARL_CONFIRMED"
  | "PATTI_FINALIZED"
  | "PMT_COMPLETED"
  | "PMT_PENDING"
  | "PAYMENT"
  | "PMT_COMPLETED"
  | "CANCEL"
  | "CANCELLED"
  | "CLOSED";

export type TPayoutDetails = {
  id: number;
  traderId: number;
  actHolder: string;
  actNum: string;
  ifsc: string;
  bank: string;
  rzpFa: string;
  rzpCont: string;
  mobile: string;
  email: string;
  status: number;
  createdOn: string;
  traderType: string;
  contactNumber: string;
  emailAddress: string;
  note1: string;
  note2: string;
  actType: string;
  type: string;
};

export type TReqAdv = {
  id: number;
  tradeId: number;
  advLimit: number;
  requestAdv: number;
  advDate: string;
  comments: string;
  advDisb: number;
  advApproved: number;
  disbDate: string;
  status: number;
  srcPartyId: number;
  mobile: string;
  srcName: string;
  images: TTradeDocument[];
  verified: number;
  imgs: TTradeDocument[];
  timeStamp: string;
  updatedOn: string;
  loanStatus: string;
  appStatus: string;
  loanId: string;
  loanAppId: number;
  loanAmt: Number;
  intOutstanding: number;
};

export type TTime = {
  hour: number;
  minute: number;
  nano: number;
  second: number;
};
export type TProgress = {
  date: string;
  id: number;
  progState: string;
  tradeId: number;
  comments: string;
  createdOn: string;
};
export type TCrop = {
  baseName: string;
  cropId: number;
  cropName: string;
  imageUrl: string;
  type: string;
  units: string;
  varietyName: string;
  qtyUnit: string;
  rateType: string | number | "";
  qty: number | "";
  weight: number | "";
  freightAmt: number | "";
  status: number;
  tradeId: number;
  weightUnit: string;
  id: number;
  destWeight: number | "";
  addWastage: number | "";
  destRate: number | "";
  rate: number | "";
  unitType?: string;
  destBayerWeight?: number | "";
  bayerWeight?: number | "";
  landingRate: number | "";
  packaging: string;
  qltyGrade: string;
  variety: string;
  size: string;
  rateCategory: string | number | "";
  cmdityCost?: number | "";
  invoiceAmt?: number | "";
  approxQty?: number | "";
  approxQtyUnit?: string;
  destQty?: number | "";
  moistureLoss?: number;
  netWeight?: number;
  pendingDelete?: boolean;
};
export type TDestinationPartner = {
  addrLine: string;
  altMobile: string;
  city: string;
  traderId: number;
  marketName: string;
  mobile: string;
  name: string;
  relMgr: string;
  rmMobile: string;
  shopNum: string;
  status: string;
  tradeName: string;
  type?: "DEST" | "SOURCE";
  traderName?: string;
};
export type TCashKycDoc = {
  id: number;
  reqId: number;
  tradeId: number;
  imgFrom: string;
  url: string;
  docType: string;
  status: number;
  type: "image" | "pdf";
  typeId: number;
  appId: number;
  pfId: number;
  docUrl: string;
  reportUrl: string;
  reportId: string;
};

export type TRecordPayoutData = {
  partyId: number | string;
  paymentDate: string;
  paidAmount: number | "";
  paymentType: string | "";
  paymentMode: string;
  comments: string;
  paymentTypeVal: string | "";
  requestAdv: number | "";
  pmtReceiptDate: string;
  desc: string;
  utr: string;
  inOutWard: string;
  fundAccId: string;
  accountNumber: string;
  otp: string;
  otpValidated: boolean;
  refId: string;
  id: number;
  availableBalance: number;
  loanAmt: number;
};
export type TAgreements = {
  id: number;
  url: string;
  type: string;
  status: number;
  pfId: number;
  reqId: number;
  addedBy: number;
  imgFrom: string;
  typeId: number;
  appId: number;
};
export enum TRatePerTypes {
  kgs = "RATE_PER_KG",
  tons = "RATE_PER_TON",
  unit = "RATE_PER_UNIT",
  piece = "RATE_PER_PIECE",
  truck = "RATE_PER_TRUCK",
}
// new demand flows types
export type TAllDemands = {
  addressLine: string;
  city: string;
  createdOn: string;
  demandId: number;
  dmdStatus: string;
  expArlDate: string;
  imageUrl: string;
  lineItem: TDemandCropLineItem[];
  marketName: string;
  pincode: number;
  profilePic: string;
  proposalCount: number;
  state: string;
  tradeName: string;
  tradeType: string;
  traderId: number;
  userName: string;
  chequeStatus: boolean;
  mobile: string;
  timestamp: string;
};
export type TDemandCropLineItem = {
  cropId: number;
  cropName: string;
  id: number;
  imageUrl: string;
  landingRate: number;
  maxPrice: number;
  minPrice: number;
  packaging: string;
  qltyGrade: string;
  qty: number;
  qtySize: string;
  qtyType: string;
  reqId: number;
  status: number;
  variety: string;
  wastageNorms: number;
};
export type TDemandById = {
  mobile: string;
  addComments: string;
  addressLine: string;
  city: string;
  createdOn: string;
  timestamp: string;
  demandId: number;
  dmdStatus: string;
  expArlDate: string;
  lineItem: TDemandCropLineItem[];
  marketName: string;
  pincode: number;
  postedOn: string;
  profilePic: string;
  proposalCount: number;
  proposals: TDemandProposals[];
  rmId: number;
  rmMobile: string;
  rmName: string;
  rmProfilePic: string;
  state: string;
  tradeName: string;
  tradeType: string;
  traderId: number;
  userName: string;
  imgs: TDemandUploadImgs[];
  tradeId: number;
  updatedOn: string;
};
export type TDemandProposals = {
  addressLine: string;
  city: string;
  dispatchDate: string;
  estArlDate: string;
  id: number;
  imgs: TDemandUploadImgs[];
  marketName: string;
  mobile: string;
  pincode: number;
  profilePic: string;
  propStatus: string;
  rate: number;
  reqId: number;
  state: string;
  timeSlot: string;
  tradeName: string;
  traderId: number;
  userName: string;
};
export type TDemandUploadImgs = {
  addedBy: number;
  appId: number;
  category: string;
  id: number;
  imgFrom: string;
  pfId: number;
  platform: string;
  reqId: number;
  reviewStatus: string;
  status: number;
  type: string;
  typeId: number;
  url: string;
};
export type TSelectTradeId = {
  tradeId: number;
  tradeName: string;
};

export type TTradePayout = {
  tradesCount: number;
  pendingRec: number;
  pendingPayable: number;
  trades: TAllTrades[];
};

export type TTraderNames = {
  pfId: number;
  firmName: string;
  name: string;
  platform: string;
};

export type TTradePmtLedger = {
  partyId: number;
  item: string;
  type: string;
  tobePaidRcvd: number;
  paidRcvd: number;
  txDate: string;
  tradeId: number;
  srcPartyId: number;
  destPartyId: number;
  date: string;
  tradeMode: string;
  arlDate: string;
  pattiDate: string;
  lbrCharges: number;
  comm: number;
  srcPf: number;
  destPf: number;
  srcPfDisc: number;
  destPfDisc: number;
  srcDisc: number;
  destDisc: number;
  salesAmt: number;
  freightPaid: number;
  misc: number;
  acceptedDate: string;
  inwardPmt: number;
  outwardPmt: number;
  freightAmt: number;
  freightAdv: number;
  cmdityCost: number;
  destDelayCharges: number;
  grnDate: string;
  tradeType: string;
  balance: number;
};
